'use client';

import { StoryblokServerComponent } from '@storyblok/react/rsc';
import clsx from 'clsx';
import { FC, useState } from 'react';
import { Slide } from 'atoms/Carousel';
import { DynamicCarousel } from 'atoms/Carousel/DynamicCarousel';
import {
  ProductGridContainer,
  ProductGridTitle,
} from 'organisms/ProductGridLayout';
import { ProductTile } from 'organisms/ProductTile';
import { HomePageTile } from 'organisms/ProductTile/HomePageTile';
import { useMediaQuery } from 'modules/mui/hooks';
import { mergeBannerWithProduct } from 'modules/shop/banners/adapter';
import { IAdaptedListProduct } from 'commerce/scayle/utils/adapter/types';
import { GridBanner } from 'commerce/services/types';
import styles from './product-grid-view2.module.css';

export const ProductsGrid: FC<{
  title?: string;
  products?: IAdaptedListProduct[];
  banners?: GridBanner[];
}> = ({ title, products = [], banners = [] }) => {
  const { isMobile } = useMediaQuery();
  const [isInitialized, setIsInitialized] = useState(false);

  return (
    <>
      {title && (
        <ProductGridTitle className={styles.title}>{title}</ProductGridTitle>
      )}
      {isMobile ? (
        <DynamicCarousel
          pagination={{ enabled: true }}
          spaceBetween={16}
          slidesPerView="auto"
          className={styles.carousel}
          onInit={() => {
            setIsInitialized(true);
          }}
        >
          {products.map((product) => (
            <Slide
              key={product.id}
              className={clsx(
                styles.slide,
                !isInitialized && styles.slideFallback,
              )}
            >
              <HomePageTile product={product} />
            </Slide>
          ))}
        </DynamicCarousel>
      ) : (
        <ProductGridContainer>
          {mergeBannerWithProduct(products, banners)?.map((entity) => {
            if ('component' in entity && entity.component === 'banner-tile') {
              return (
                <StoryblokServerComponent key={entity._uid} blok={entity} />
              );
            } else if (!('component' in entity)) {
              return <ProductTile key={entity.id} product={entity} />;
            } else {
              return null;
            }
          })}
        </ProductGridContainer>
      )}
    </>
  );
};
